import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const AkcniProdejNd = {
	name: NAME,
	apiProvider,
	router,
};
